import Header from './Header';

import compose from 'recompose/compose';
import withProps from 'recompose/withProps';

import { withModel } from '../../data-providers/model';
import withMediaQueries from '../../hocs/withMediaQueries';

const enhance = compose(
  withModel,
  withMediaQueries,
  withProps(props => props.model.prismicHeaderModel)
);

export default enhance(Header);
